import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from '../home-page/home-page.component';
import {PanotestModule} from '../panotest/panotest.module';
import {PanotestComponent} from '../panotest/panotest.component';

const routes: Routes = [
  { path: '',
    component: PanotestComponent
  },
  {
    path: 'planner', loadChildren: () =>
      import('../panotest/panotest.module').then(m => m.PanotestModule)
  }

];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {initialNavigation: 'enabled'})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

